// extracted by mini-css-extract-plugin
module.exports = {"root":"NextQuestionButton_root__28XtX","inner":"NextQuestionButton_inner__3vpIg","default":"NextQuestionButton_default__1cFnS","subdued":"NextQuestionButton_subdued__3pMEA"};